module.exports = __webpack_public_path__ + "static/img/pro9_tab4.2763348.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro9_tab4.jpg
// module id = lvhz
// module chunks = 171